module.exports = __webpack_public_path__ + "img/media.73f203c5.jpg";